module.exports = __webpack_public_path__ + "static/media/aicdmb.551e87ec.png";